import styled from "styled-components";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Profile from "../../components/allies/Me/Profile";
import Sidebar from "../../components/allies/Me/Sidebar";
import Info from "../../components/allies/Me/Info";
import { mobile } from "../../styles/responsive";
import { useAlly } from "../../context/ally";
import AllyService from "../../services/ally.service";


export default function AllyMe() {
    const {setAllyInfo, 
        user
    } = useAlly()
    const navigate = useNavigate()
    const router = useNavigate()
    function back() {
        navigate('/ally')
    }

    useEffect(() => {
        if (!user) return router('/ally/access')
    }, [user, router])

    useEffect(() => {
        async function me() {
            try {
                const response = await (await AllyService.me()).data
                setAllyInfo(response)
            } catch (error) {
                console.log(error)
            }
        }
        me()
    }, [])

    return (
        <Main>
            <Navbar>
                <button onClick={back}>
                    <IoMdArrowRoundBack/>
                </button>
            </Navbar>
            <Left>
                <Profile/>
                <Sidebar/>
            </Left>
            <Right>
                <Info/>
            </Right>
        </Main>
    )
}

const Main = styled.div`
display: grid;
width: 80%;
margin: auto;
min-height: 100dvh;
padding-bottom: 5vh;
grid-template-columns: 1fr 1fr 1fr;
/* grid-template-rows: 70px 1fr 1fr; */
/* ${mobile({
    width: '90%'
})} */
`

const Navbar = styled.div`
grid-column: 1 / -1;
padding: 20px 0;
button {
    height: 30px;
    width: 30px;
    background-color: rgba(0,0,0,0);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #000;
}
`

const Left = styled.div`
grid-column: 1 / span 1;
${mobile({
    gridColumn: '1 / -1',
    gridRow: '2 / span 1'
})}
`
const Right = styled.div`
grid-column: 2 / -1;
${mobile({
    gridColumn: '1 / -1',
    gridRow: '3 / span 1'
})}
`